<template>
  <b-autocomplete v-model="query" :data="filteredTeachers" field="fullName"
    placeholder="Lehrkraft suchen" aria-label="Lehrkraft auswählen"
    append-to-body open-on-focus clearable @select="selectTeacher">
    <template #empty>Keine Ergebnisse</template>
  </b-autocomplete>
</template>

<script>
export default {
  props: {
    value: { type: Object, default: () => ({}) },
    teachers: { type: Array, default: () => [] },
  },
  data() {
    return { query: '' };
  },
  computed: {
    selectedName() {
      return this.teacherName(this.value);
    },
    filteredTeachers() {
      const query = this.query === this.selectedName ? '' : this.query.trim().toLocaleLowerCase('de');
      return this.teachers.map((teacher) => ({
        ...teacher, fullName: this.teacherName(teacher),
      })).filter((teacher) => teacher.fullName.toLocaleLowerCase('de').includes(query));
    },
  },
  watch: {
    selectedName: {
      immediate: true,
      handler(name) { this.query = name; },
    },
  },
  methods: {
    teacherName(teacher) {
      return teacher ? [teacher.firstname, teacher.lastname].filter(Boolean).join(' ') : '';
    },
    selectTeacher(teacher) {
      if (teacher) this.$emit('input', teacher);
    },
  },
};
</script>
